import CategoriesItemFurniture from "./CategoriesItemFurniture.jsx";
import Footer from "../Footer.jsx";
import Newsletter from "../Newsletter.jsx";

function Furnitures() {
  return (
    <>
      <CategoriesItemFurniture />
      <Newsletter />
      <Footer />
    </>
  );
}

export default Furnitures;
